import { DocProperty } from 'typescript-openapi-router';
import { CropModel } from './crop-model';

export class DeviceResponseModel {

  @DocProperty({
    type: 'string',
    isRequired: false
  })
  id: string;

  @DocProperty({
    type: 'number',
    isRequired: false
  })
  organizationId: number;

  @DocProperty({
    type: 'string',
    isRequired: false
  })
  organizationName: string;

  @DocProperty({
    type: 'string',
    isRequired: false
  })
  alias: string;

  @DocProperty({
    type: 'object',
    objectType: CropModel.name,
    isRequired: false
  })
  crop?: CropModel;

  @DocProperty({
    type: 'number',
    isRequired: false
  })
  alertCount?: number;

  @DocProperty({
    type: 'string',
    isRequired: false
  })
  serialNumber?: string;

  @DocProperty({
    type: 'string',
    isRequired: false
  })
  comment?: string;

}
